<template>
  <LogIn @updateLanguage="updateLanguage" :languagestrings="languagestrings" :toperror="toperror" />
</template>

<script>
  import LogIn from '../components/LogIn';

  export default {
    name: 'LoginView',

    components: {
      LogIn,
    },

    props: ['languagestrings', 'toperror'],
    
    methods: {
      updateLanguage(language) {
        this.$emit("updateLanguage", language);
      }
    },

    created: function(){
    }
  }
</script>
